import Vue from 'vue'
import zh from './lang/zh'
import en from './lang/en'

// 所有语言包
const messages = {
  zh: zh,   // 假设 locale = 'zh'
  en: en    // 假设 locale = 'en'
}
// 响应式的语言状态
const state = Vue.observable({
  locale: 'zh'   // 当前语言标识
})

// 翻译函数：根据 key 获取当前语言的对应文本
function $t(key) {
  const langPack = messages[state.locale]
  // 如果 langPack 是 undefined，这里会报错
  if (!langPack) {
    console.warn(`语言包未加载: ${state.locale}`)
    return key
  }
  return langPack[key] || key
}

// 切换语言的方法
export function setLocale(lang) {
  if (messages[lang]) {
    state.locale = lang;
    // 如果当前路由没有变化，手动更新 SEO
    if (typeof window !== 'undefined') {
      const { updateGlobalSeo } = require('@/utils/seo');
      updateGlobalSeo(lang);
    }
  }
}

// 导出插件对象（Vue 插件格式）
export default {
  install(Vue) {
    // 挂载到 Vue 原型，所有组件都能用
    Vue.prototype.$t = $t
    Vue.prototype.$setLocale = setLocale
    // 可选：提供一个全局状态，便于 watch
    Vue.prototype.$i18nState = state
  }
}



// WEBPACK FOOTER //
// ./src/i18n.js